/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3CampaignDeviceCaps } from '../models/V3CampaignDeviceCaps';
import { HttpFile } from '../http/http';

/**
* Inventory configuration for StackAdapt campaign
*/
export class V3StackAdaptInventoryConfig {
    /**
    * List of inventory package IDs for the campaign
    */
    'inventoryPackageIds'?: Array<string>;
    /**
    * Whether the inventory packages are strict
    */
    'isInventoryPackagesStrict'?: boolean;
    /**
    * Device types for the rule. Must be one of 'CONNECTED_DEVICE', 'CONNECTED_TV', 'DESKTOP', 'DOOH', 'PHONE', 'SET_TOP', 'TABLET'
    */
    'deviceTypes'?: Array<string>;
    'deviceCaps'?: V3CampaignDeviceCaps;
    /**
    * Supply types for the campaign. Must be one of 'APP', 'WEB', 'DOOH'
    */
    'supplyTypes'?: Array<string>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "inventoryPackageIds",
            "baseName": "inventoryPackageIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "isInventoryPackagesStrict",
            "baseName": "isInventoryPackagesStrict",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "deviceTypes",
            "baseName": "deviceTypes",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "deviceCaps",
            "baseName": "deviceCaps",
            "type": "V3CampaignDeviceCaps",
            "format": ""
        },
        {
            "name": "supplyTypes",
            "baseName": "supplyTypes",
            "type": "Array<string>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptInventoryConfig.attributeTypeMap;
    }

    public constructor() {
    }
}

